import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BaseModule } from '@base/base.module';
import { IbanInputDirective } from '@base/directives/ibaninput.directive';
import { SharedForAllModule } from '@base/shared-for-all.module';
import { TrilogyComponentsModule } from '@base/trilogy.module';

import { ModalRecoveryComponent } from '@app/modules/mobile-recovery/modal-recovery/modal-recovery.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonModule, ModalRef, ModalService, SliderModule } from '@trilogy';

import { MobileRecoveryConfiguratorComponent } from './configurator/mobile-recovery-configurator.component';
import { ModalRecoveryListingComponent } from './modal-recovery/modal-recovery-listing/modal-recovery-listing.component';
import { ModalRecoveryResultComponent } from './modal-recovery/modal-recovery-result/modal-recovery-result.component';
import { ModalRecoverySearchComponent } from './modal-recovery/modal-recovery-search/modal-recovery-search.component';

@NgModule({
    declarations: [
        ModalRecoveryComponent,
        ModalRecoverySearchComponent,
        ModalRecoveryListingComponent,
        ModalRecoveryResultComponent,
        MobileRecoveryConfiguratorComponent,
        IbanInputDirective,
    ],
    imports: [
        BaseModule,
        CommonModule,
        ButtonModule,
        FormsModule,
        NgbModule,
        TrilogyComponentsModule,
        SharedForAllModule,
        SliderModule,
        ReactiveFormsModule,
    ],
    providers: [ModalRef, ModalService],
    exports: [MobileRecoveryConfiguratorComponent],
})
export class MobileRecoveryModule {}
